import React from 'react'
import styled from 'styled-components'
import { isEmpty } from 'lodash'
import parse from 'html-react-parser'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { VocSentence } from 'types/vocSentence'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import TagGroup from './TagGroup'
import { VocText } from './shared.css'

const StyledTagContent = styled.span`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
  line-height: ${sys.typescale[14].lineHeight};
  font-size: ${sys.typescale[14].size};
  font-weight: 500;
  gap: 8px;
  display: flex;
  flex-flow: row wrap;
`

const StyledTagUnderTextContent = styled(StyledTagContent)`
  padding-top: 8px;
`

type InternalContentComponentProps = {
  vocSentence: VocSentence
  highlighting?: boolean
  index: number
}

const InternalContentComponent = ({
  vocSentence,
  highlighting,
  index
}: InternalContentComponentProps) => {
  const theme = useDisplayTheme() as Theme
  const { displayText, highlightedText, tags } = vocSentence

  const text = highlighting ? highlightedText! : displayText!
  const testId = `${AutomationId.soundbiteDefaultFrame.vocContent}-${index}`

  return text ? (
    <VocText mode={theme} data-testId={testId}>
      {parse(text)}
      {!isEmpty(tags) && (
        <StyledTagUnderTextContent mode={theme}>
          <TagGroup tags={tags} />
        </StyledTagUnderTextContent>
      )}
    </VocText>
  ) : (
    <VocText mode={theme} data-testId={testId}>
      {!isEmpty(tags) && (
        <StyledTagContent mode={theme}>
          <TagGroup tags={tags} />
        </StyledTagContent>
      )}
    </VocText>
  )
}

export default InternalContentComponent
